export default "__VITE_ASSET__Bo0SzH4S__"